import type { ReactNode } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import { ToastContainer } from 'react-toastify'
import { SiteSettingsProvider } from '@/context/SiteSettingsContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 30 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
      structuralSharing: true,
    },
  },
})

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <SiteSettingsProvider>
          {children}
        </SiteSettingsProvider>
        <ToastContainer
          position="top-right"
          stacked={false}
          autoClose={3500}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable={false}
          limit={3}
          theme="light"
          toastClassName="qbc-toast"
          className="qbc-toast-container"
          progressClassName="qbc-toast-progress"
          closeButton={false}
          icon={({ type }) => {
            const icons = {
              success: '✓',
              error: '!',
              warning: '!',
              info: 'i',
              default: '•',
            }
            return (
              <span className="qbc-toast-icon" aria-hidden>
                {icons[type] ?? icons.default}
              </span>
            )
          }}
        />
      </QueryClientProvider>
    </HelmetProvider>
  )
}
